import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

const regEx = /[^a-z0-9]/gi;

const Radio = ({
  checked, onClick, label, id
}) => {
  const radioId = id || `input-${label.toLowerCase().replace(regEx, '')}`;

  return (
    <div className={styles.checkboxContainer} onClick={onClick}>
      <div
        className={`${styles.box} ${checked ? styles.checked : ''}`}
        id={radioId}
      />
      <label
        className={styles.checkboxLabel}
        id={`label-${label.toLowerCase().split(' ').join('_')}`}
        htmlFor={radioId}
      >
        {label}
      </label>
    </div>
  );
};

Radio.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  id: PropTypes.string,
};

export default Radio;
